// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 1805) return "static/chunks/25f4ac2a-05dedc243d858fd8.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"47":"c699a451","6700":"react-leaflet-core","8168":"react-leaflet"}[chunkId] || chunkId) + "." + {"47":"17483e1dc67a32c7","5368":"3273375a18657923","6700":"75592b7e7d566758","8168":"32c7cc26454850d7"}[chunkId] + ".js";
};